// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lightbox {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 105;
}
.lightbox .lightbox-content {
  background: #FDFBFB;
  border-radius: 20px;
  padding: 10px;
  max-width: 80%;
  max-height: 80%;
  overflow: auto;
  margin-top: 100%;
  transition: all 350ms;
}
.lightbox.lightbox-media {
  flex-direction: column;
}
.lightbox.lightbox-media .lightbox-content {
  margin-top: 140%;
}
.lightbox.lightbox-media.open {
  transition-delay: 300ms;
}
.lightbox.lightbox-media .lightbox-close {
  padding: 0;
  margin-top: 20px;
  z-index: 10;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.75rem;
  flex: 0 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lightbox video {
  height: 100%;
  width: 100%;
}
.lightbox.open {
  top: 0;
}
.lightbox.open .lightbox-content {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/Lightbox.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAEA;EACI,oCAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADJ;AAEI;EACI,mBCLO;EDMP,mBCmCU;EDlCV,aCqCA;EDpCA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AAGI;EACI,sBAAA;AADR;AAEQ;EACA,gBAAA;AAAR;AAEQ;EACI,uBAAA;AAAZ;AAEQ;EACI,UAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAZ;AAGI;EACI,YAAA;EACA,WAAA;AADR;AAGI;EACI,MAAA;AADR;AAEQ;EACI,aAAA;AAAZ","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n.lightbox {\n    background-color: rgba(0, 0, 0, 0.8);\n    position: fixed;\n    top: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;   \n    z-index: 105; \n    .lightbox-content {\n        background: $color__white;\n        border-radius: $border-radius3;\n        padding: $marge2;\n        max-width: 80%;\n        max-height: 80%;\n        overflow: auto;\n        margin-top:100%;\n        transition: all 350ms;\n    }\n    \n    &.lightbox-media{\n        flex-direction: column;\n        .lightbox-content {\n        margin-top: 140%;\n        }\n        &.open {\n            transition-delay: 300ms;\n        }\n        .lightbox-close{\n            padding:0;\n            margin-top:20px;\n            z-index: 10;\n            width: 1.5rem;\n            height: 1.5rem;\n            font-size: 0.75rem;\n            flex: 0 0 1.5rem;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n    video{\n        height: 100%;\n        width: 100%;\n    }\n    &.open {\n        top: 0;\n        .lightbox-content {\n            margin-top:0;\n        }\n        \n    }\n\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
